import 'css-chunksrc/feature/menu/Menu.module.scss';export default {
  "root": "Menu_root",
  "show_menu_group_buttons": "Menu_show_menu_group_buttons"
};